import React from 'react';

import headerStyles from './AlmeHeader.styles';

import { withStyles, WithStyles, makeStyles, createStyles } from '@material-ui/core/styles';

import {
    Theme, Accordion, AccordionDetails, AccordionSummary,
    Typography, Container, Box, TypographyProps,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AlmeHeaderConfig } from './AlmeHeaderConfig';
import { AlmeCloseConfig } from '../AlmeClose/AlmeCloseConfig';
import { AlmeMinimizeConfig } from '../AlmeMinimize/AlmeMinimizeConfig';
import AlmeCloseConfigTool from '../AlmeClose/AlmeCloseConfigTool';
import AlmeMinimizeConfigTool from '../AlmeMinimize/AlmeMinimizeConfigTool';
import AlmeMoreMenuConfigTool from '../AlmeMoreMenu/AlmeMoreMenuConfigTool';
import { AlmeMoreMenuConfig } from '../AlmeMoreMenu/AlmeMoreMenuConfig';
import AlmeConfigFormControl, { BoolPropTypes, ConfigControlGroups } from '../AlmeConfigFormControl/AlmeConfigFormControl';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeHeaderConfigToolProps extends WithStyles<typeof headerStyles> {
    almeConfig: AlmeHeaderConfig;
    onConfigChange: (almeConfig: AlmeHeaderConfig) => void;
}

const AlmeHeaderConfigTool: React.FC<AlmeHeaderConfigToolProps> = (props: AlmeHeaderConfigToolProps) => {
    const classes = useStyles();

    const onMinimizeConfigChange = (minimizeConfig: AlmeMinimizeConfig): void => {
        const headerConfig: AlmeHeaderConfig = {
            header: {
                ...props.almeConfig.header,
                minimize: {
                    ...minimizeConfig.minimize,
                },
            },
        };
        props.onConfigChange(headerConfig);
    };

    const onCloseConfigChance = (closeConfig: AlmeCloseConfig): void => {
        const headerConfig: AlmeHeaderConfig = {
            header: {
                ...props.almeConfig.header,
                close: {
                    ...closeConfig.close,
                },
            },
        };
        props.onConfigChange(headerConfig);
    };

    const onMoreMenuConfigChange = (moreConfig: AlmeMoreMenuConfig): void => {
        const headerConfig: AlmeHeaderConfig = {
            header: {
                ...props.almeConfig.header,
                moreMenu: {
                    ...moreConfig.moreMenu,
                },
            },
        };
        props.onConfigChange(headerConfig);
    };

    const headerHasBorder = props.almeConfig.header.styles.hasBorder.toString() as BoolPropTypes;
    const headerTextFont = props.almeConfig.header.styles.headerTextFont;

    const setHeaderHasBorder = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as BoolPropTypes;
        const almeConfig = props.almeConfig;
        almeConfig.header.styles.hasBorder = newValue === 'true';
        props.onConfigChange(almeConfig);
    };

    const setHeaderTextFont = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as TypographyProps['variant'];
        const almeConfig = props.almeConfig;
        almeConfig.header.styles.headerTextFont = newValue;
        props.onConfigChange(almeConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'Header',
            controlGroups: [
                {
                    label: 'Header Border',
                    name: 'headerHasBorder',
                    value: headerHasBorder,
                    changeHandler: setHeaderHasBorder,
                    radioButtons: ['true', 'false'],
                },
                {
                    label: 'Header Text Font',
                    name: 'headerTextFont',
                    value: headerTextFont,
                    changeHandler: setHeaderTextFont,
                    radioButtons: ["button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "subtitle1", "subtitle2", "body1", "body2", "overline", "srOnly"],
                },
            ],
        },
    ];

    return (
        <Box className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-alme-header-config-tool-content"
                    id="panel-alme-header-config-tool-header"
                >
                    <Typography variant='h6'>Alme Header Config Tools</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Container>
                        <AlmeMinimizeConfigTool almeConfig={props.almeConfig.header} onConfigChange={onMinimizeConfigChange} />
                        <AlmeMoreMenuConfigTool almeConfig={props.almeConfig.header} onConfigChange={onMoreMenuConfigChange} />
                        <AlmeConfigFormControl title="Alme Header Config" configControls={configControls} />
                        <AlmeCloseConfigTool almeConfig={props.almeConfig.header} onConfigChange={onCloseConfigChance} />
                    </Container>
                </AccordionDetails>
            </Accordion>
        </Box >
    );
};

export default withStyles(headerStyles)(AlmeHeaderConfigTool);